var map = {
	"./Barberia.png": 416,
	"./Card-corp.png": 398,
	"./Cards.png": 539,
	"./Encriptador.png": 966,
	"./Fylo.png": 329,
	"./GitHub.png": 859,
	"./Linkedin.png": 615,
	"./Whatsapp.png": 471,
	"./fondo-desktop.png": 221,
	"./fondo-movile.png": 523,
	"./logo.png": 946,
	"./logo2.png": 929,
	"./perfil.png": 876,
	"./portfolio-lesly.png": 483,
	"./portfolio.png": 147,
	"./profile.png": 239,
	"./puntos.png": 833
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 713;